import { useState } from "react";
import { downloadTabs } from "@/mocks/home";

export default function DownloadSection() {
  const [active, setActive] = useState(downloadTabs[0].key);
  const current = downloadTabs.find((t) => t.key === active) ?? downloadTabs[0];

  return (
    <section id="download" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-download-2-line"></i>
              App 下载
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
              App 下载与安装指南
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              不同设备对应不同的下载与安装方式。先选择你的设备类型，再按下列步骤操作，
              即可完成安装。首次安装遇到安全提示属于正常现象，按说明放行即可。
            </p>
          </div>

          <div className="mt-9 inline-flex flex-wrap gap-2 p-1 rounded-full bg-background-100 border border-background-200/70">
            {downloadTabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActive(tab.key)}
                className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  active === tab.key
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-200/60"
                }`}
              >
                <i className={tab.icon}></i>
                {tab.label}
              </button>
            ))}
          </div>

          <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
            <div className="lg:col-span-2 rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-7">
              <div className="flex items-center gap-3">
                <span className="w-12 h-12 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center">
                  <i className={`${current.icon} text-2xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{current.label}</h3>
                  <p className="text-xs text-foreground-500">按下列顺序完成安装即可</p>
                </div>
              </div>

              <ol className="mt-6 space-y-4">
                {current.points.map((point, idx) => (
                  <li key={point} className="flex gap-3">
                    <span className="mt-0.5 w-6 h-6 shrink-0 rounded-full bg-accent-100 text-accent-800 text-xs font-medium flex items-center justify-center">
                      {idx + 1}
                    </span>
                    <p className="text-sm text-foreground-700 leading-relaxed">{point}</p>
                  </li>
                ))}
              </ol>
            </div>

            <div className="rounded-lg bg-secondary-50 border border-secondary-200/70 p-5 md:p-6 h-full">
              <h3 className="font-heading text-base font-semibold text-foreground-950">版本信息</h3>
              <dl className="mt-4 space-y-3 text-sm">
                <div className="flex items-center justify-between gap-3 pb-3 border-b border-secondary-200/60">
                  <dt className="text-foreground-500">当前版本</dt>
                  <dd className="font-medium text-foreground-950">{current.version}</dd>
                </div>
                <div className="flex items-center justify-between gap-3 pb-3 border-b border-secondary-200/60">
                  <dt className="text-foreground-500">安装包大小</dt>
                  <dd className="font-medium text-foreground-950">{current.size}</dd>
                </div>
                <div className="flex items-center justify-between gap-3 pb-3 border-b border-secondary-200/60">
                  <dt className="text-foreground-500">系统要求</dt>
                  <dd className="font-medium text-foreground-950 text-right">{current.requirement}</dd>
                </div>
                <div className="flex items-center justify-between gap-3">
                  <dt className="text-foreground-500">更新方式</dt>
                  <dd className="font-medium text-foreground-950">覆盖安装</dd>
                </div>
              </dl>
              <div className="mt-5 flex items-start gap-2 rounded-md bg-background-50 px-4 py-3">
                <i className="ri-information-line text-accent-600 mt-0.5"></i>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  请始终从官网入口获取安装包，避免使用第三方渠道来源不明的版本。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}